import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import * as classes from './classes.module.scss';

const renderPrice = (itemsPrice, discount, currency) => (
  discount > 0 ? (
    <>
      <s>
        { currency }
        { itemsPrice.toFixed(2) }
      </s>
      &nbsp;
      { currency }
      { (itemsPrice - discount).toFixed(2) }
    </>
  ) : (
    <>
      { currency }
      { itemsPrice.toFixed(2) }
    </>
  )
);

const WallGroup = ({
  name, badge, times, count, itemsPrice, discount, currency, complete, showHeader, onAddGroup
}) => {
  if (!showHeader) {
    return null;
  }

  return (
    <div className={ classes.groupHeader }>
      {
        // Only a group still earning its discount is titled — everything else is shown as
        // plain individual pieces, so it keeps the count and the bulk button and nothing else.
        name ? (
          <div className={ classes.groupTitle }>
            { name }
            {
              badge ? (
                <span className={ classes.badge }>
                  { badge }
                </span>
              ) : null
            }
            { times > 1 ? ` ×${ times }` : null }
          </div>
        ) : null
      }
      <div className={ classes.groupPrice }>
        { count }
        &nbsp;items&nbsp;
        { renderPrice(itemsPrice, discount, currency) }
      </div>
      <div className={ classes.groupButton }>
        <Button fluid onClick={ onAddGroup }>
          { complete ? 'ADD WALL TO CART' : `ADD ${ count } ITEMS TO CART` }
        </Button>
      </div>
    </div>
  );
};

WallGroup.propTypes = {
  name: PropTypes.string,
  badge: PropTypes.string,
  times: PropTypes.number,
  count: PropTypes.number.isRequired,
  itemsPrice: PropTypes.number,
  discount: PropTypes.number,
  currency: PropTypes.string,
  complete: PropTypes.bool,
  showHeader: PropTypes.bool,
  onAddGroup: PropTypes.func.isRequired
};

export default WallGroup;
